/* eslint-disable react/prop-types */
import React from 'react';
import { useTheme } from 'styled-components';
import { formatCurrency } from 'shared/formatCurrency';
import { tokens } from '../tokens';

// Text cells shared by the ledger-based report tables (account report, admin
// Revenue page). Money is right-aligned tabular-nums; `strong` colours it
// orange for profit columns. Card/column titles live in DataTable
// (HeaderLabel); CSV helpers live in shared/csv.

export const Money = ({ value, strong, negative, bold }) => {
  const t = tokens(useTheme());
  return (
    <span
      style={{
        fontSize: 14,
        fontWeight: strong || bold ? 700 : 500,
        color: negative ? '#D63A24' : strong ? t.primary : t.text,
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap',
      }}
    >
      {formatCurrency(value)}
    </span>
  );
};

// Plain number cell (counts), themed and tabular; `bold` for totals rows.
export const Num = ({ value, bold }) => {
  const t = tokens(useTheme());
  return (
    <span
      style={{
        fontSize: 14,
        fontWeight: bold ? 700 : 500,
        color: t.text,
        fontVariantNumeric: 'tabular-nums',
      }}
    >
      {Number(value || 0).toLocaleString('en-US')}
    </span>
  );
};

// Whole-number split of two amounts that always adds to 100, e.g. [60, 40].
// Null when there is nothing to split.
export const splitPercent = (a, b) => {
  const total = (a || 0) + (b || 0);
  if (total <= 0) return null;
  const first = Math.round((100 * (a || 0)) / total);
  return [first, 100 - first];
};

// "60% / 40%" cell for a two-way share (app vs POS, cash vs card). Shows a
// dash when neither side has any money.
export const Split = ({ a, b }) => {
  const t = tokens(useTheme());
  const split = splitPercent(a, b);
  return (
    <span
      style={{
        fontSize: 14,
        fontWeight: 500,
        color: split ? t.text : t.faint,
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap',
      }}
    >
      {split ? `${split[0]}% / ${split[1]}%` : '—'}
    </span>
  );
};

// Bold primary text cell (event / order / account names).
export const Strong = ({ children }) => {
  const t = tokens(useTheme());
  return (
    <span
      style={{
        fontSize: 14.5,
        fontWeight: 700,
        color: t.text,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'block',
        minWidth: 0,
      }}
    >
      {children}
    </span>
  );
};
